// extracted by mini-css-extract-plugin
module.exports = {"energyBadgeDot":"EnergyBadgeDot_energyBadgeDot__5WHx3"};